import makeGetBaseLink from "features/common/routing/ends-with-routes/makeGetBaseLink";

export default function makeInternalLink(pathEndings: string[]) {
  const getBaseLink = makeGetBaseLink(pathEndings);

  return (linkEnding: string) => {
    const _linkEnding = linkEnding.startsWith("/")
      ? linkEnding.slice(1)
      : linkEnding;

    const baseLink = getBaseLink(window.location.pathname);

    const _baseLink = baseLink.endsWith("/") ? baseLink.slice(0, -1) : baseLink;

    return `${_baseLink}/${_linkEnding}`;
  };
}
